/**
 * Floyd commerce tracking.
 * Event names and payloads are frozen by docs/TRACKING-FREEZE.md.
 * This deferred asset must load before floyd-product-variants.js.
 */

/* Product variant tracking consumers */
(function () {
    var storefrontSwatchInitialized = false;
    var lastTrackedVariantChangeId = '';

    function getCurrentProductVariantId() {
        var productForm = document.querySelector('product-form form, product-form');
        var variantInput = productForm && productForm.querySelector('input[name="id"]');
        return variantInput && variantInput.value ? String(variantInput.value) : '';
    }

    document.addEventListener('swatch:initialized', function (e) {
        if (e.detail && e.detail.context === 'wheel-configurator') return;
        console.log('Initiale Farbe:', e.detail.caseColor);
        // Shopify Google & YouTube owns the initial product view.
        // Seed the current variant so only real post-load changes are tracked here.
        lastTrackedVariantChangeId = getCurrentProductVariantId();
        storefrontSwatchInitialized = true;
        document.dispatchEvent(new CustomEvent('floyd:recommended-variants:update'));
    });
    document.addEventListener('swatch:changed', function (e) {
        if (e.detail && e.detail.context === 'wheel-configurator') return;
        console.log('Geänderte Farbe:', e.detail.caseColor);
        document.dispatchEvent(new CustomEvent('floyd:recommended-variants:update'));
    });
    document.addEventListener('swatch:clicked', function (e) {
        if (e.detail && e.detail.context === 'wheel-configurator') return;
        console.log('Klick auf Farbe:', e.detail.caseColor);
        document.dispatchEvent(new CustomEvent('floyd:recommended-variants:update'));
    });

    document.addEventListener('variant:change', function (e) {
        if (!storefrontSwatchInitialized) return;

        var variant = e.detail && e.detail.variant;
        var variantId = variant && variant.id ? String(variant.id) : '';
        if (!variantId || variantId === lastTrackedVariantChangeId) return;

        lastTrackedVariantChangeId = variantId;
        trackProductView(variant);
    });

    // Tracking
    window.addEventListener('click', (evt) => {
        if (evt.target.classList.contains('shopify-payment-button__button')) {
            trackBeginCheckoutWithCurrentProduct();
        }
    }, { capture: true });

    // Track begin checkout with the current product.
    function trackBeginCheckoutWithCurrentProduct() {
        function getText(sel) {
            const n = document.querySelector(sel);
            return n ? n.textContent.trim() : undefined;
        }

        function readVisiblePrice() {
            const el = document.querySelector('price-list sale-price');
            if (!el) return undefined;
            const txt = el.textContent.replace(/\s+/g, ' ').trim(); // e.g. "595,00 €"
            const num = txt.replace(/[^\d,.,-]/g, '').replace(',', '.'); // "595.00"
            const v = parseFloat(num);
            return Number.isFinite(v) ? v : undefined;
        }

        const buildPayload = () => {
            const productForm = document.querySelector('product-form form, product-form'); // form inside product-form
            if (!productForm) return null;

            // Identifiers
            const variantId = productForm.querySelector('input[name="id"]')?.value;
            const productId = productForm.querySelector('input[name="product-id"]')?.value;
            const item_id = String(variantId || productId || '');

            // Product title
            const item_name = document.querySelector('.product-title').textContent.trim();
            // Variant title, when available
            const item_variant = document.querySelector('.variant-picker__option-info span')?.textContent.trim();
            // Price, preferably from the form
            const price = readVisiblePrice();

            // Currency
            const currency = window.Shopify?.currency?.active
                || document.documentElement.getAttribute('data-shop-currency')
                || 'EUR';

            // Validate required fields
            if (!item_id || !item_name || price == null) return null;

            const item = {
                item_id,
                item_name,
                item_variant,
                price,
                quantity: 1
            };

            return {
                event: 'begin_checkout',
                currency,
                value: item.price * item.quantity,
                items: [item]
            };
        };

        const payload = buildPayload();
        if (payload) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(payload);
        }
    }

    // trackProductView
    function trackProductView(variantOverride) {
        function getText(sel) {
            const n = document.querySelector(sel);
            return n ? n.textContent.trim() : undefined;
        }

        function readVisiblePrice() {
            const el = document.querySelector('price-list sale-price');
            if (!el) return undefined;
            const txt = el.textContent.replace(/\s+/g, ' ').trim(); // e.g. "595,00 €"
            const num = txt.replace(/[^\d,.,-]/g, '').replace(',', '.'); // "595.00"
            const v = parseFloat(num);
            return Number.isFinite(v) ? v : undefined;
        }

        const buildPayload = () => {
            const productForm = document.querySelector('product-form form, product-form'); // form inside product-form
            if (!productForm) return null;

            // Identifiers
            const variantId = variantOverride?.id || productForm.querySelector('input[name="id"]')?.value;
            const productId = productForm.querySelector('input[name="product-id"]')?.value;
            const item_id = String(variantId || productId || '');

            // Product title
            const item_name = document.querySelector('.product-title').textContent.trim();
            // Use the fresh variant from the Prestige variant:change event.
            const item_variant = variantOverride?.public_title
                || variantOverride?.option1
                || variantOverride?.title
                || document.querySelector('.variant-picker__option-info span')?.textContent.trim();
            // Use the event price after a variant change; otherwise use the visible price.
            const price = Number.isFinite(variantOverride?.price)
                ? variantOverride.price / 100
                : readVisiblePrice();

            // Currency
            const currency = window.Shopify?.currency?.active
                || document.documentElement.getAttribute('data-shop-currency')
                || 'EUR';

            // Validate required fields
            if (!item_id || !item_name || price == null) return null;

            const item = {
                item_id,
                item_name,
                item_variant,
                price,
                quantity: 1
            };

            return {
                event: 'view_item',
                currency,
                value: item.price * item.quantity,
                items: [item]
            };
        };

        const payload = buildPayload();
        if (payload) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(payload);
            console.log('view_item', payload);
        }
    }


})();
